export enum ExtrasFormEnum {
    RetrievedFlightIdentifier = 'retrievedFlightIdentifier',
    TravellerIdentifier = 'travellerIdentifier',
    BaggageOptionCode = 'baggageOptionCode',
    NoBag = 'NOBAG',
    NoLounge = 'NOLOUNGE'
  }